import { render, staticRenderFns } from "./dataPropuestEpro.vue?vue&type=template&id=0a888f00&scoped=true&"
import script from "./dataPropuestEpro.vue?vue&type=script&lang=js&"
export * from "./dataPropuestEpro.vue?vue&type=script&lang=js&"
import style0 from "./dataPropuestEpro.vue?vue&type=style&index=0&id=0a888f00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a888f00",
  null
  
)

export default component.exports